import React from "react";

import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: { padding: 20 },
  section: {fontSize: 12, marginBottom: 10 },
  header: { fontSize: 12, fontWeight: "bold", marginBottom: 10, textAlign: "center" },
  table: { border: "1 solid black", marginTop: 10 },
  row: { flexDirection: "row", borderBottom: "1 solid black",borderLeft:"1 solid black"  },
  cell: { flex: 1, textAlign: "center", fontSize: 10, padding: 5, borderRight: "1 solid black"},
  boldCell: { flex: 1, textAlign: "center", fontSize: 10, fontWeight: "bold", padding: 5, borderRight: "1 solid black" },
//   lastCell: { borderRight: "none" }, // No right border for last column
//   noBorder: { borderRight: "none", borderBottom: "none" }, // Hide border for empty rows
  firstColumn: { flex: 0.5 }, // S.No column smaller
});

const PackingListPDF = ({ data }) => {
  if (!data) return null;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.header}>BEST FASHIONS</Text>
          <Text style={styles.header}>Packing List</Text>
          <Text>Date: {new Date().toLocaleDateString()}</Text>
          <Text>TO : {data.buyer_name}</Text>
          <Text></Text>
          <Text>Style: {data.style_name}</Text>
        </View>

        {/* Table Header */}
        <View style={[styles.row, styles.table]}>
          <Text style={[styles.boldCell, styles.firstColumn]}>S.No</Text>
          <Text style={styles.boldCell}>Box No</Text>
          <Text style={styles.boldCell}>Model No</Text>
          <Text style={styles.boldCell}>Size</Text>
          <Text style={styles.boldCell}>Quantity</Text>
          <Text style={[styles.boldCell, styles.lastCell]}>Total</Text>
        </View>

        {/* Table Data */}
        {data.logs.map((log, index) => {
          const sizeEntries = Object.entries(log.formated_size_key);
          console.log(sizeEntries);
          
          return sizeEntries.map(([size, quantity], i) => (

            <View key={`${index}-${i}`} style={styles.row}>
              {/* Show S.No, Box No, and Model No only in the first row of each group */}
              {i === 0 ? (
                <>
                  <Text style={[styles.cell, styles.firstColumn]} rowSpan={sizeEntries.length}>{index + 1}</Text>
                  <Text style={styles.cell} rowSpan={sizeEntries.length}>{log.box_no}</Text>
                  <Text style={styles.cell} rowSpan={sizeEntries.length}>{data.style_no}</Text>
                </>
              ) : (
                <>
                  <Text style={[styles.cell, styles.firstColumn, styles.noBorder]}></Text>
                  <Text style={[styles.cell, styles.noBorder]}></Text>
                  <Text style={[styles.cell, styles.noBorder]}></Text>
                </>
              )}
              
              {/* Display Size and Quantity */}
              <Text style={styles.cell}>{size}</Text>
              <Text style={styles.cell}>{quantity}</Text>

              {/* Display Total only in the LAST row of each group */}
              {i === sizeEntries.length - 1 ? (
                <Text style={[styles.cell, styles.lastCell]}>{log.total_piece}</Text>
              ) : (
                <Text style={[styles.cell, styles.noBorder]}></Text>
              )}
            </View>
          ));
        })}
      </Page>
    </Document>
  );
};

export default PackingListPDF;
